<template>
  <v-bottom-sheet v-model="show" persistent>
    <v-col>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Abra em um navegador</v-card-title>
            <v-card-text>
              <p>
                Você está acessando pelo {{ appLabel }}. Alguns recursos, como verificação de segurança e pagamento, podem não funcionar corretamente aqui.
              </p>
              <br>
              <p>
                Para continuar, toque em <strong>{{ menuInstruction }}</strong> no canto superior direito e escolha
                <strong>"Abrir no navegador"</strong>{{ appLabel === "TikTok" ? "" : " (Chrome ou Safari)" }}.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-row justify="end">
                <v-col cols="12" class="d-flex flex-column justify-end mb-4">
                  <v-btn
                    class="mx-2"
                    variant="text"
                    color="default"
                    @click="dismissFallback"
                  >
                    Continuar mesmo assim
                  </v-btn>
                  <br>
                  <v-btn
                    class="mx-2"
                    variant="flat"
                    color="primary"
                    @click="handleCopyLink"
                  >
                    Copiar link
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-bottom-sheet>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useInAppBrowser } from "@/composables/useInAppBrowser";
import { useSnackbar } from "@/stores/snackbar";

const { app, platform, showFallback, copyCurrentUrl, dismissFallback } = useInAppBrowser();
const snackbar = useSnackbar();

const show = computed<boolean>({
  get() {
    return showFallback.value;
  },
  set(value: boolean) {
    if (!value) dismissFallback();
  },
});

const appLabel = computed<string>(() => app.value === "tiktok" ? "TikTok" : "Instagram");

const menuInstruction = computed<string>(() => {
  if (platform.value === "ios") return "•••";

  return "⋮";
});

const handleCopyLink = async (): Promise<void> => {
  const copied = await copyCurrentUrl();

  if (copied) {
    snackbar.show("Link copiado! Cole em uma nova aba do navegador.", "success");

    return;
  }

  snackbar.show("Não foi possível copiar o link automaticamente.", "warning");
};

defineOptions({
  name: "TheInAppBrowserOverlay",
});
</script>
